import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";
import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";

import CascateList from "../../../../../../common/components/cascate_list";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * Header
 */

type Props = {
  idCentroCusto: number | null;
  idFuncionario: number | null;
  centroCustos: CentroCustoDropDown[];
  funcionarios: FuncionarioDropDown[];
  onCentroCustoChange: (idCentroCusto: number | null) => void;
  onFuncionarioChange: (idCentroCusto: number | null) => void;
  onClear: () => void;
};

export const Header = ({
  idCentroCusto,
  idFuncionario,
  centroCustos,
  funcionarios,
  onCentroCustoChange,
  onFuncionarioChange,
  onClear,
}: Props) => {
  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 grid-flow-row-dense">
            <DefaultAutocomplete
              label="Funcionário"
              options={funcionarios}
              getOptionLabel={x => x.nome}
              getOptionKey={x => x.idFuncionario}
              value={funcionarios.find(f => f.idFuncionario === idFuncionario)}
              onChange={f => onFuncionarioChange(f?.idFuncionario ?? null)} />

            <DefaultAutocomplete
              label="Centro de Custo"
              options={centroCustos}
              getOptionLabel={x => x.title}
              getOptionKey={x => x.id}
              value={centroCustos.find(f => f.id === idCentroCusto)}
              onChange={f => onCentroCustoChange(f?.id ?? null)} />

          </div>

          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={onClear}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}